namespace Matrix.Workflow {
    export class QueueColumns {
        static columnsKey = 'Workflow.Queue';
    }
}
